<template>
  <div class="flex bg-white rounded shadow ring-1 ring-black ring-opacity-5 justify-between">
    <div class="p-2 space-x-2">
      <VDropdown theme="ghost" placement="bottom-start">
        <BaseLinkButton purple class="flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            class="w-5 h-5 inline-flex -ml-1"
          >
            <path
              d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z"
            />
          </svg>
          <span class="inline-flex"> Add </span>
        </BaseLinkButton>
        <template #popper>
          <div
            class="w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100"
          >
            <div class="py-1">
              <button
                type="button"
                class="group flex items-center px-4 py-2 focus:outline-none w-full text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                v-close-popper
                @click="$emit('add-line')"
              >
                Empty line
              </button>
              <button
                type="button"
                class="group flex items-center px-4 py-2 focus:outline-none w-full text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                v-close-popper
                @click="$emit('add-product', { type: 'package' })"
              >
                Package
              </button>
              <button
                type="button"
                class="group flex items-center px-4 py-2 focus:outline-none w-full text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                v-close-popper
                @click="$emit('add-product', { type: 'basic' })"
              >
                Product
              </button>
              <button
                type="button"
                class="group flex items-center px-4 py-2 focus:outline-none w-full text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                v-close-popper
                @click="$emit('add-product', { type: 'service' })"
              >
                Service
              </button>
              <button
                type="button"
                class="group flex items-center px-4 py-2 focus:outline-none w-full text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                v-close-popper
                @click="openMembershipProductsModal"
              >
                Membership
              </button>
            </div>
          </div>
        </template>
      </VDropdown>
    </div>
    <div class="p-2">
      <BaseLinkButton purple @click="$emit('update:specs-visible', !specsVisible)">
        {{ specsVisible ? 'Hide' : 'Show' }} Specs
      </BaseLinkButton>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderFormOrderItemsToolbar',
  props: {
    specsVisible: Boolean,
  },
  methods: {
    openMembershipProductsModal() {
      this.$modal.show({
        component: () => import('@/components/Order/addProductDialog/AddProductDialog.vue'),
        props: {},
        on: {
          add: (orderLines) => {
            this.$emit('add-order-lines', orderLines);
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
